import apiClient from "./api";

export interface PurchaseOrder {
  id: number;
  poNumber: string;
  poDate: string;
  clientName: string;
  subClientId?: number;
  subClientName?: string;
  statusID: number;
  statusName?: string;
  priorityName?: string;
  priorityID?: number;
  signatureRequired?: boolean;
  fromInventory?: boolean;
  invoiced?: boolean;
  patientCount?: number;
  createdDate: string;
}

export interface CreatePurchaseOrderData {
  toEntityID: number;
  clientID: number;
  subClientId?: number;
  poNumber: string;
  poDate: string;
  clientName: string;
  subClientName?: string;
  comment?: string;
  statusID?: number;
  priorityID: number;
  signatureRequired: boolean;
  fromInventory?: boolean;
  details: {
    chargeID: number;
    qty: number;
    patientID?: number;
    patientExternalID?: string;
    cost: number;
    charge: number;
  }[];
}

export const purchaseOrderService = {
  getPurchaseOrders: async (statusID?: number, limit = 50, offset = 0) => {
    const response = await apiClient.get("/purchase-orders", {
      params: { statusID, limit, offset },
    });
    return response.data;
  },

  getPurchaseOrderById: async (id: number) => {
    const response = await apiClient.get(`/purchase-orders/${id}`);
    return response.data;
  },

  createPurchaseOrder: async (data: CreatePurchaseOrderData) => {
    const response = await apiClient.post("/purchase-orders", data);
    return response.data;
  },

  updatePurchaseOrderStatus: async (id: number, statusID: number) => {
    await apiClient.patch(`/purchase-orders/${id}/status`, { statusID });
  },

  getCharges: async () => {
    const response = await apiClient.get("/purchase-orders/charges/list");
    return response.data;
  },

  deletePurchaseOrder: async (id: number, confirmPoNumber: string) => {
    await apiClient.delete(`/purchase-orders/${id}`, {
      data: { confirmPoNumber },
    });
  },

  getNextPoNumber: async () => {
    const response = await apiClient.get("/purchase-orders/next-po-number");
    return response.data.nextPoNumber;
  },
};
